// TODO: Remove modal and waitlist
if (!customElements.get('vbb-product-form-reactive')) {
  customElements.define('vbb-product-form-reactive', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.cart = document.querySelector("cart-drawer")
      this.form = this.querySelector("form");
      if (this.form) {
        this.form.addEventListener("submit", this.handleAddToCart.bind(this));
      }
      this.addEventListener("click", (event) => {
        event.stopPropagation();
      })
      this.querySelector("button.card-hover")?.addEventListener(
        "click",
        (e) => {
          e.preventDefault();
          this.querySelector(".vbb-product-card").classList.toggle("hover-active");
        }
      );
    }

    listenToVariantSelectorChange() {
      document.addEventListener('variant:selected', ({ detail }) => {
        if (detail.productFormId === this.id) {
          this.setActiveVariant(detail.variantId);

          this.dispatchEvent(new CustomEvent('variant:changed', {
            detail: {
              productFormId: this.id,
              variantId: this.activeVariantId,
            },
            bubbles: true,
          }));
        }
      });
    }

    setActiveVariant(newVariantId) {
      this.activeVariantId = newVariantId;
      this.activeVariant = this.variantDetails.find(variant => variant.variantId === newVariantId);
    }

    handleAddToCart(event) {
      event.preventDefault();

      const cartDrawer = document.querySelector("cart-drawer");

      if (!cartDrawer.loading) {
        // this.hideError();

        const productFormConfig = fetchConfig("javascript");
        productFormConfig.headers["x-requested-with"] = "XMLHttpRequest";
        delete productFormConfig.headers["Content-Type"];

        const formData = new FormData(this.form);

        let sellingPlanValue = null;

        // Remove selling_plan from the form data and store its value
        for (let [name, value] of [...formData.entries()]) {
          if (name === "selling_plan") {
            sellingPlanValue = value;
            formData.delete(name);
          }
        }

        // Re-add selling_plan as items[0][selling_plan]
        if (sellingPlanValue) {
          formData.append("items[0][selling_plan]", sellingPlanValue);
        }

        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        for (let [name, value] of formData.entries()) {
          console.log(name + ": " + value);
        }

        productFormConfig.body = formData;
        console.log(formData);
        this.cart.open();
        this.cart.setLoading();

        fetch(routes.cart_add_url, productFormConfig)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // this.showError(response.message);
              console.log(response.status);
              this.cart.setNotLoading();
              this.cart.close();
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            } else {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "vbb-product-form-reactive",
              });

              this.cart.renderContents(response);
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            if (this.cart && this.cart.classList.contains("is-empty")) {
              this.cart.classList.remove("is-empty");
            }

            this.cart.setNotLoading();
          });
      }
    }

    connectedCallback() {
      this.id = this.dataset.id;
      this.activeVariant = null;
      this.activeVariantId = +(this.dataset.activeVariant);

      this.variantDetails = JSON.parse(this.querySelector(`#variant-details-${this.id}`).textContent);

      this.setActiveVariant(this.activeVariantId);

      this.listenToVariantSelectorChange();
    }
  });
}
